module.exports = "\r\n\r\n\r\n\r\n<router-outlet>  \r\n\r\n    \r\n\r\n\r\n</router-outlet>\r\n\r\n\r\n\r\n\r\n"